import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  Grid,
  Box,
  FormControl,
  FormLabel,
  Typography,
  FormControlLabel,
  FormGroup,
  Checkbox,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid rgba(0, 0, 0, 0.1)`,
    borderRadius: 4,
    position: 'relative',
    width: '220px',
    height: '260px',
  },
  img: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  opacityLayer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, var(--opacity))',
  },
  // Text should be same color as in pdf template
  text: {
    color: '#fff',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
}));

const ImagePreview = props => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { src, opacity } = props;

  const renderedOpacity = typeof opacity === 'number' ? opacity : props.defaultOpacity;

  return (
    <Box className={classes.root} my={3}>
      {src ? <img className={classes.img} src={src} alt="" /> : null}
      <div className={classes.opacityLayer} style={{'--opacity': renderedOpacity / 100}}></div>
      <div className={classes.text}>{t('imagePreview:imagePreview')}</div>
    </Box>
  );
};

ImagePreview.propTypes = {
  src: PropTypes.string,
  opacity: PropTypes.number,
  defaultOpacity: PropTypes.number,
}

export default ImagePreview;
